import bankList from './bankList';
import type { Bank } from './bankList';

export default function getBankFromAccount(account: string): Bank | null {
  const id = account && parseInt(account.substring(4, 7), 10);

  return bankList.find(value => value.identificationCode.includes(id as number)) || null;
}
